<template>
  <BooksIcon name="spinner" status="saving muted" hidden-text="saving" />
</template>

<script lang="ts">
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'UtilitySaving',
});
</script>
